import {createContext, useContext} from 'react'
import type {FilterQueryRequest} from '../filter-request'
import type {ARIAFilterSuggestion, FilterSuggestion} from '../types'
import type {AnchorPosition} from '@primer/behaviors'

interface SuggestionsContext {
  activeSuggestion: number | null
  hideSuggestions: () => void
  isFetchingSuggestions: boolean
  position?: AnchorPosition
  suggestions: ARIAFilterSuggestion[]
  showSuggestions: () => void
  suggestionsListRef: React.RefObject<HTMLDivElement>
  suggestionSelected: (value: FilterSuggestion) => void
  suggestionsVisible?: boolean
  updateSuggestions: (query: FilterQueryRequest) => Promise<void>
}

export const SuggestionsContext = createContext<SuggestionsContext | undefined>(undefined)

export const useSuggestions = () => {
  const context = useContext(SuggestionsContext)
  if (!context) {
    throw new Error('useSuggestions must be used inside a SuggestionsContext')
  }

  return context
}

try{ SuggestionsContext.displayName ||= 'SuggestionsContext' } catch {}